<template>
  <div v-if="showPopup" class="coming-soon-overlay">
    <!-- Secret Code Input Modal -->
    <div v-if="showSecretInput" class="secret-modal-overlay" @click="hideSecretInput">
      <div class="secret-modal" @click.stop>
        <!-- Header -->
        <div class="secret-header">
          <h3 class="secret-title">Kod Akses Pembangun</h3>
          <button class="secret-close" @click="hideSecretInput">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Content -->
        <div class="secret-content">
          <div class="secret-description">
            Masukkan kod rahsia untuk mengakses sistem sebelum pelancaran rasmi
          </div>
          
          <div class="secret-input-group">
            <div class="secret-input-wrapper">
              <input 
                ref="secretInput"
                v-model="secretCode"
                type="password"
                class="secret-input"
                placeholder="Masukkan kod rahsia..."
                maxlength="20"
                @keyup.enter="checkSecretCode"
                @keyup.escape="hideSecretInput"
              />
            </div>
          </div>

          <!-- Error Message -->
          <div v-if="secretError" class="secret-error-message">
            <i class="fa fa-exclamation-triangle"></i>
            Kod tidak sah. Sila cuba lagi.
          </div>
        </div>

        <!-- Footer Actions -->
        <div class="secret-footer">
          <button class="secret-action-btn cancel" @click="hideSecretInput">
            <i class="fa fa-times"></i>
            Batal
          </button>
          <button class="secret-action-btn verify" @click="checkSecretCode">
            <i class="fa fa-check"></i>
            Sahkan
          </button>
        </div>
      </div>
    </div>

    <div class="coming-soon-container">
      <!-- Logo Section -->
      <div class="logo-section">
        <img src="/images/logog.png" alt="AIMS Logo" class="logo-image">
        <h1 class="system-title">ARTIFICIAL INSEMINATION<br>MANAGEMENT SYSTEM</h1>
      </div>

      <!-- Coming Soon Content -->
      <div class="content-section">
        
        <h2 class="main-heading">Sistem AIMS Akan Dilancarkan Tidak Lama Lagi</h2>


        <!-- Countdown Timer -->
        <div class="countdown-section">
          <h3 class="countdown-label">Sistem akan aktif dalam:</h3>
          <div class="countdown-timer">
            <div class="time-unit">
              <span class="time-value">{{ countdown.days }}</span>
              <span class="time-label">HARI</span>
            </div>
            <div class="time-separator">:</div>
            <div class="time-unit">
              <span class="time-value">{{ countdown.hours }}</span>
              <span class="time-label">JAM</span>
            </div>
            <div class="time-separator">:</div>
            <div class="time-unit">
              <span class="time-value">{{ countdown.minutes }}</span>
              <span class="time-label">MINIT</span>
            </div>
            <div class="time-separator">:</div>
            <div class="time-unit">
              <span class="time-value">{{ countdown.seconds }}</span>
              <span class="time-label">SAAT</span>
            </div>
          </div>
        </div>

        <!-- Progress Bar -->
        <div class="progress-section">
          <div class="progress-info">
            <span>Progress Menuju Pelancaran</span>
            <span class="progress-percentage">{{ progressPercentage }}%</span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
          </div>
        </div>

        <!-- Launch DateTime Display -->
        <div class="launch-info">
          <div class="launch-datetime">
            <i class="fa fa-calendar-alt"></i>
            <span>Tarikh Pelancaran: {{ formattedLaunchDate }}</span>
          </div>
          <div class="launch-datetime">
            <i class="fa fa-clock"></i>
            <span>Masa Pelancaran: {{ formattedLaunchTime }}</span>
          </div>
        </div>

        <!-- Contact Information -->
        <!-- <div class="contact-section">
          <p class="contact-text">Untuk maklumat lanjut, sila hubungi:</p>
          <div class="contact-info">
            <div class="contact-item">
              <i class="fa fa-envelope"></i>
              <span>aims@dvs.gov.my</span>
            </div>
            <div class="contact-item">
              <i class="fa fa-phone"></i>
              <span>03-8870 1400</span>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Footer -->
      <div class="footer-section">
        <p>© 2025 Jabatan Perkhidmatan Veterinar</p>
      </div>
    </div>

    <!-- Secret Code Hint (Only visible when konami sequence is entered) -->
    <div v-if="showHint" class="secret-hint">
      💡 Press Ctrl+Shift+D to enter bypass code
    </div>

    <!-- Animated Background Elements -->
    <div class="bg-animation">
      <div class="floating-icon" v-for="n in 6" :key="n" :style="getFloatingIconStyle(n)">
        <i class="fa fa-paw"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonPopup',
  props: {
    launchDateTime: {
      type: String,
      required: true
    },
    secretBypassCode: {
      type: String,
    }
  },
  data() {
    return {
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      showPopup: true,
      timer: null,
      startTime: new Date(),
      
      // Secret code functionality
      showSecretInput: false,
      secretCode: '',
      secretError: false,
      showHint: false,
      konamiSequence: ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'KeyB', 'KeyA'],
      konamiIndex: 0,
      keySequence: [],
      lastKeyTime: 0
    }
  },
  computed: {
    targetDate() {
      return new Date(this.launchDateTime)
    },
    formattedLaunchDate() {
      return this.targetDate.toLocaleDateString('ms-MY', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    formattedLaunchTime() {
      return this.targetDate.toLocaleTimeString('ms-MY', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
    },
    progressPercentage() {
      const now = new Date()
      const target = this.targetDate.getTime()
      
      // Show progress based on proximity to launch time
      // Let's use 2 hours (120 minutes) as full timeframe
      const totalMinutes = 48 * 60
      const timeRemaining = target - now.getTime()
      const minutesRemaining = Math.max(0, timeRemaining / (1000 * 60))
      
      if (minutesRemaining <= 0) return 100
      if (minutesRemaining >= totalMinutes) return 0
      
      const progress = ((totalMinutes - minutesRemaining) / totalMinutes) * 100
      return Math.round(progress)
    }
  },
  mounted() {
    // Check if bypass is already active
    if (this.checkBypassStatus()) {
      this.showPopup = false
      return
    }

    this.updateCountdown()
    this.timer = setInterval(this.updateCountdown, 1000)
    
    // Store original overflow value
    this.originalOverflow = document.body.style.overflow
    // Prevent page scroll when popup is active
    document.body.style.overflow = 'hidden'
    
    // Disable context menu and keyboard shortcuts (but allow secret codes)
    document.addEventListener('contextmenu', this.preventAction)
    document.addEventListener('keydown', this.handleKeyDown)
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    // Restore original overflow
    document.body.style.overflow = this.originalOverflow || 'auto'
    
    // Remove event listeners
    document.removeEventListener('contextmenu', this.preventAction)
    document.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    checkBypassStatus() {
      // Check sessionStorage first (for current tab)
      const sessionBypass = sessionStorage.getItem('aims_bypass_coming_soon')
      if (sessionBypass && this.isValidBypass(sessionBypass)) {
        return true
      }
      
      // Check localStorage (for persistent bypass across tabs)
      const localBypass = localStorage.getItem('aims_bypass_coming_soon')
      if (localBypass && this.isValidBypass(localBypass)) {
        // Copy to sessionStorage for current tab
        sessionStorage.setItem('aims_bypass_coming_soon', localBypass)
        return true
      }
      
      // Check if current time is past launch date (permanent bypass)
      const now = new Date().getTime()
      const target = this.targetDate.getTime()
      if (now >= target) {
        return true
      }
      
      return false
    },

    updateCountdown() {
      const now = new Date().getTime()
      const target = this.targetDate.getTime()
      const difference = target - now

      if (difference <= 0) {
        // Time's up! Hide popup and reload page
        this.bypassPopup()
        return
      }

      // Calculate time units
      this.countdown.days = Math.floor(difference / (1000 * 60 * 60 * 24))
      this.countdown.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.countdown.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      this.countdown.seconds = Math.floor((difference % (1000 * 60)) / 1000)
    },
    
    handleKeyDown(e) {
      const currentTime = Date.now()
      
      // Reset sequence if too much time passed
      if (currentTime - this.lastKeyTime > 1000) {
        this.konamiIndex = 0
        this.keySequence = []
      }
      this.lastKeyTime = currentTime

      // Check for Konami code (Up, Up, Down, Down, Left, Right, Left, Right, B, A)
      if (e.code === this.konamiSequence[this.konamiIndex]) {
        this.konamiIndex++
        if (this.konamiIndex === this.konamiSequence.length) {
          this.showHint = true
          this.konamiIndex = 0
          setTimeout(() => {
            this.showHint = false
          }, 5000)
          e.preventDefault()
          return
        }
      } else {
        this.konamiIndex = 0
      }

      // Check for Ctrl+Shift+D to open secret input
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        this.showSecretInput = true
        e.preventDefault()
        setTimeout(() => {
          if (this.$refs.secretInput) {
            this.$refs.secretInput.focus()
          }
        }, 100)
        return
      }

      // Check for triple ESC press
      this.keySequence.push(e.key)
      if (this.keySequence.length > 3) {
        this.keySequence.shift()
      }
      if (this.keySequence.length === 3 && this.keySequence.every(key => key === 'Escape')) {
        this.showSecretInput = true
        this.keySequence = []
        e.preventDefault()
        setTimeout(() => {
          if (this.$refs.secretInput) {
            this.$refs.secretInput.focus()
          }
        }, 100)
        return
      }

      // Original prevention logic (but allow our secret keys)
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && e.key === 'I') ||
        (e.ctrlKey && e.shiftKey && e.key === 'J') ||
        (e.ctrlKey && e.key === 'U') ||
        (e.ctrlKey && e.key === 'R') ||
        e.key === 'F5'
      ) {
        e.preventDefault()
        return false
      }
    },

    showSecretInputModal() {
      this.showSecretInput = true
      this.secretCode = ''
      this.secretError = false
      setTimeout(() => {
        if (this.$refs.secretInput) {
          this.$refs.secretInput.focus()
        }
      }, 100)
    },

    hideSecretInput() {
      this.showSecretInput = false
      this.secretCode = ''
      this.secretError = false
    },

    checkSecretCode() {
      if (this.secretCode === this.secretBypassCode) {
        // Correct code! Store bypass status with 8-hour expiration
        const bypassData = {
          type: 'secret',
          timestamp: Date.now(),
          expires: Date.now() + (8 * 60 * 60 * 1000) // 8 hours in milliseconds
        }
        
        // Store in both sessionStorage (cleared when tab closes) and localStorage (persists)
        sessionStorage.setItem('aims_bypass_coming_soon', JSON.stringify(bypassData))
        localStorage.setItem('aims_bypass_coming_soon', JSON.stringify(bypassData))
        
        this.bypassPopup(false) // Don't reload immediately
      } else {
        // Wrong code
        this.secretError = true
        this.secretCode = ''
        setTimeout(() => {
          this.secretError = false
        }, 3000)
      }
    },

    isValidBypass(bypassString) {
      try {
        const bypassData = JSON.parse(bypassString)
        
        // Check if it's the new format with expiration
        if (bypassData.type === 'secret' && bypassData.expires) {
          const now = Date.now()
          
          // If expired, clean up storage
          if (now >= bypassData.expires) {
            this.clearExpiredBypass()
            return false
          }
          
          return true
        }
        
        // Handle old format (if any exists)
        return false
      } catch (e) {
        // Handle very old format where it was just 'true'
        if (bypassString === 'true') {
          // Convert old format to new format with 8-hour expiration from now
          const bypassData = {
            type: 'secret',
            timestamp: Date.now(),
            expires: Date.now() + (8 * 60 * 60 * 1000)
          }
          
          sessionStorage.setItem('aims_bypass_coming_soon', JSON.stringify(bypassData))
          localStorage.setItem('aims_bypass_coming_soon', JSON.stringify(bypassData))
          
          return true
        }
        
        return false
      }
    },

    clearExpiredBypass() {
      sessionStorage.removeItem('aims_bypass_coming_soon')
      localStorage.removeItem('aims_bypass_coming_soon')
    },

    bypassPopup(shouldReload = true) {
      // Optional: Show a message about when popup will return
      const bypassData = sessionStorage.getItem('aims_bypass_coming_soon')
      if (bypassData && !shouldReload) {
        try {
          const data = JSON.parse(bypassData)
          if (data.expires) {
            const hoursRemaining = Math.ceil((data.expires - Date.now()) / (1000 * 60 * 60))
            console.log(`Popup bypassed for ${hoursRemaining} more hours`)
          }
        } catch (e) {
          // Handle parsing error silently
        }
      }

      this.showPopup = false
      clearInterval(this.timer)
      document.body.style.overflow = this.originalOverflow || 'auto'
      
      // Remove event listeners
      document.removeEventListener('contextmenu', this.preventAction)
      document.removeEventListener('keydown', this.handleKeyDown)
      
      // Only reload if specified (for normal countdown completion)
      if (shouldReload) {
        setTimeout(() => {
          window.location.reload()
        }, 500)
      }
    },

    getFloatingIconStyle(index) {
      const positions = [
        { top: '15%', left: '10%', animationDelay: '0s' },
        { top: '25%', right: '15%', animationDelay: '2s' },
        { top: '45%', left: '5%', animationDelay: '4s' },
        { top: '65%', right: '20%', animationDelay: '1s' },
        { top: '80%', left: '15%', animationDelay: '3s' },
        { top: '75%', right: '10%', animationDelay: '5s' }
      ]
      
      return positions[index - 1] || {}
    },
    
    preventAction(e) {
      e.preventDefault()
      return false
    }
  }
}
</script>

<style scoped>
.coming-soon-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #0a0c1a 0%, #1a1f3a 25%, #2d3561 50%, #1a1f3a 75%, #0a0c1a 100%);
  z-index: 9999999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-family: 'Chakra Petch', sans-serif;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2rem 0;
}

/* Secret Input Modal Styles */
.secret-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000000;
  backdrop-filter: blur(5px);
}

.secret-modal {
  background: linear-gradient(145deg, #1a1f3a, #0a0c1a);
  border: 2px solid #3b82f6;
  border-radius: 15px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.secret-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.secret-icon {
  font-size: 1.5rem;
  color: #64b5f6;
}

.secret-title {
  color: #64b5f6;
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  flex: 1;
  text-align: left;
}

.secret-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
}

.secret-content {
  text-align: left;
}

.secret-description {
  font-size: 0.9rem;
  color: #b3c1d1;
  margin-bottom: 1.5rem;
}

.secret-input-group {
  margin-bottom: 1.5rem;
}

.secret-input-wrapper {
  position: relative;
}

.secret-input-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #64b5f6;
}

.secret-input {
  width: 100%;
  padding: 12px 16px;
  padding-left: 40px;
  border: 2px solid #3b82f6;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 16px;
  font-family: 'Chakra Petch', sans-serif;
  margin-bottom: 1rem;
  text-align: center;
  letter-spacing: 2px;
}

.secret-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: normal;
}

.secret-input:focus {
  outline: none;
  border-color: #64b5f6;
  box-shadow: 0 0 0 3px rgba(100, 181, 246, 0.3);
}

.secret-error-message {
  margin-top: 1rem;
  color: #ff5252;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.secret-error-message i {
  margin-right: 0.5rem;
}

.secret-footer {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.secret-action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Chakra Petch', sans-serif;
  flex: 1;
}

.secret-action-btn.cancel {
  background: linear-gradient(45deg, #f44336, #ef5350);
  color: white;
}

.secret-action-btn.cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.4);
}

.secret-action-btn.verify {
  background: linear-gradient(45deg, #4caf50, #66bb6a);
  color: white;
}

.secret-action-btn.verify:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.secret-hint {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(45deg, #ff9800, #ffa726);
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: 600;
  z-index: 10000001;
  animation: fadeInOut 5s ease-in-out;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.4);
}

/* Rest of the original styles remain the same */
.coming-soon-container {
  max-width: 800px;
  width: 90%;
  text-align: center;
  color: white;
  padding: 2rem;
  position: relative;
  z-index: 10;
  margin: auto 0;
  min-height: calc(100vh - 4rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-section {
  margin-bottom: 2rem;
}

.logo-image {
  width: 120px;
  height: auto;
  margin-bottom: 1rem;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

.system-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  line-height: 1.4;
  margin: 0;
}

.content-section {
  margin-bottom: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.coming-soon-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(45deg, #ff6b35, #ff8e53);
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 2rem;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
  animation: pulse 2s infinite;
}

.main-heading {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  background: linear-gradient(45deg, #64b5f6, #42a5f5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.description {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  color: #b3c1d1;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.countdown-section {
  margin-bottom: 2rem;
}

.countdown-label {
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
  color: #90caf9;
  font-weight: 500;
}

.countdown-timer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.time-unit {
  background: linear-gradient(145deg, #1e3a8a, #1e40af);
  border: 2px solid #3b82f6;
  border-radius: 15px;
  padding: 1.5rem 1rem;
  min-width: 80px;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
  position: relative;
  overflow: hidden;
}

.time-unit::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.time-unit:hover::before {
  left: 100%;
}

.time-value {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.time-label {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #90caf9;
  margin-top: 0.5rem;
}

.time-separator {
  font-size: 2rem;
  font-weight: 700;
  color: #64b5f6;
  animation: blink 1s infinite;
}

.progress-section {
  margin-bottom: 2rem;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 1rem;
  color: #90caf9;
}

.progress-percentage {
  font-weight: 600;
  color: #64b5f6;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #42a5f5, #64b5f6);
  border-radius: 10px;
  transition: width 0.3s ease;
  position: relative;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 2s infinite;
}

.launch-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

.launch-datetime {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-size: 1.1rem;
  color: #90caf9;
  background: rgba(255, 255, 255, 0.05);
  padding: 1rem 1.5rem;
  border-radius: 10px;
  border: 1px solid rgba(144, 202, 249, 0.2);
}

.launch-datetime i {
  color: #64b5f6;
  font-size: 1.2rem;
}

.contact-section {
  margin-bottom: 1rem;
}

.contact-text {
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #90caf9;
}

.contact-info {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: #b3c1d1;
}

.contact-item i {
  color: #64b5f6;
}

.footer-section {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
  color: #78909c;
  font-size: 0.9rem;
  margin-top: auto;
}

/* Background Animation */
.bg-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.floating-icon {
  position: absolute;
  color: rgba(100, 181, 246, 0.1);
  font-size: 2rem;
  animation: float 6s ease-in-out infinite;
}

/* Animations */
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0.3; }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes float {
  0%, 100% { 
    transform: translateY(0px) rotate(0deg);
    opacity: 0.1;
  }
  25% { 
    transform: translateY(-20px) rotate(90deg);
    opacity: 0.2;
  }
  50% { 
    transform: translateY(-40px) rotate(180deg);
    opacity: 0.1;
  }
  75% { 
    transform: translateY(-20px) rotate(270deg);
    opacity: 0.2;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
  20%, 80% { opacity: 1; transform: translateX(-50%) translateY(0); }
  100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .coming-soon-overlay {
    padding: 1rem 0;
  }
  
  .coming-soon-container {
    padding: 1rem;
    min-height: calc(100vh - 2rem);
  }

  .main-heading {
    font-size: 2rem;
  }

  .system-title {
    font-size: 1.3rem;
  }

  .countdown-timer {
    gap: 0.5rem;
  }

  .time-unit {
    padding: 1rem 0.75rem;
    min-width: 70px;
  }

  .time-value {
    font-size: 1.8rem;
  }

  .contact-info {
    flex-direction: column;
    gap: 1rem;
  }

  .launch-info {
    gap: 0.5rem;
  }

  .launch-datetime {
    font-size: 1rem;
    padding: 0.75rem 1rem;
  }
  
  .logo-section {
    margin-bottom: 1.5rem;
  }
  
  .content-section {
    margin-bottom: 1.5rem;
  }

  .secret-modal {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .time-unit {
    padding: 0.75rem 0.5rem;
    min-width: 60px;
  }

  .time-value {
    font-size: 1.5rem;
  }

  .time-label {
    font-size: 0.8rem;
  }
  
  .main-heading {
    font-size: 1.7rem;
  }
  
  .system-title {
    font-size: 1.1rem;
  }
}

@media (max-height: 700px) {
  .coming-soon-container {
    min-height: auto;
    padding: 1rem;
  }
  
  .logo-section {
    margin-bottom: 1rem;
  }
  
  .content-section {
    margin-bottom: 1rem;
  }
  
  .countdown-section {
    margin-bottom: 1.5rem;
  }
  
  .progress-section {
    margin-bottom: 1.5rem;
  }
  
  .launch-info {
    margin-bottom: 1.5rem;
  }
}
</style>